export default "https://cdn-static.gokick.com/assets/e693edcab6ba034c0ea6bea85be7a795ed1fbf27/images/citrus-zen.2d0942f5031f42be498b3d61071e3237.png";